import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { InsuranceInformation } from 'src/app/core/interfaces/insuranceInformation';
import { InsurancePolicyService } from 'src/app/core/services/insurance-policy.service';
import { IntegrationEnum } from 'src/app/core/enums/integration.enum';

@Injectable({
    providedIn: 'root'
})
export class UploadDownloadMapService {

    policyCompany: InsuranceInformation;

    constructor(
        private authService: AuthService,
        private insurancePolicyService: InsurancePolicyService
    ) { }

    isPolicyExpirated(): boolean {
        return this.insurancePolicyService.isExpired(this.policyCompany);
    }

    setPolicy(policyCompany: InsuranceInformation) {
        this.policyCompany = policyCompany;
    }

    getPolicyCompany(): InsuranceInformation {
        return this.policyCompany;
    }

    getHasSiigoIntegration(): boolean {
        return this.authService && this.authService.getCompany() && this.authService.getCompany().integrationCredentials &&
          this.authService.getCompany().integrationCredentials.length &&
          this.authService.getCompany().integrationCredentials.some(integration => integration && integration.integrationChannel &&
            integration.integrationChannel.toLowerCase() === IntegrationEnum.SIIGO.toLowerCase() && integration.state);
    }

}
